import { DataActionType } from "../constants";
import { IDataActions, IDataCategoryLinks, IUserData } from "../types";

export const initialUserData: IUserData = {
    defaultCategoryKey: "",
    data: [
    {
        _id: "",
        tagName: "",
        links: [
            {
                _id: "",
                title: "",
                url: ""
            }
        ]
    }
]}

export const UserDataReducer = (initialUserData: IUserData, action: IDataActions): IUserData => {
    switch (action.type) {
        case DataActionType.UPDATE_DATA:
            const defaultKey = action.payload.filter((elem: IDataCategoryLinks): boolean=>elem.tagName==="general")
            return {...initialUserData, data: action.payload, defaultCategoryKey: defaultKey[0]._id};
        default:
            throw Error("No such user data action");
    }
}